(function () {
    'use strict';

    angular.module("imApp").factory("stockCountRefreshService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 982,
                    parameters: parms || {}
                });
            },
            refreshStock: function (edit) {
                return $ihttp.post({
                    method: 981,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
